"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reservationInvoiceActionsColumn = void 0;
const actionsColumn_1 = require("../../Table/columns/actionsColumn");
const actions_1 = require("../List/actions");
const layouts = {
    editReservation: actions_1.editReservation,
    payReservation: actions_1.payReservation,
};
exports.reservationInvoiceActionsColumn = (0, actionsColumn_1.createActionsColumn)({
    columnsNumber: 2,
    rowsNumber: 1,
    layouts,
    order: [
        'editReservation',
        'payReservation',
    ],
});
//# sourceMappingURL=actionsColumn.js.map